
import Component from "vue-class-component"
import {Prop} from "vue-property-decorator"
import ApiHtmlTable from "@/report/components/ApiHtmlTable.vue"
import ApiChart from "@/report/components/ApiChart.vue"
import Page from "@/report/pages/Page.vue"
import {Chart, Table} from "@/report/pages/AbstractPage.vue"
import _ from "lodash"

@Component({components: {ApiHtmlTable, ApiChart}})
export default class BiSectionPage extends Page {
  @Prop({default: null})
  style1: string | null

  @Prop({default: false})
  style1DefaultBg: boolean

  @Prop({default: null})
  style2: string | null

  @Prop({default: false})
  style2DefaultBg: boolean

  @Prop({default: null})
  yAxisLabel: string | null

  get renderChartsInFirstSection(): boolean {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    return !!(this.chartResources?.length && this.tableResources?.length)
  }

  get firstChart(): Chart | undefined {
    return _.first(this.chartResources)
  }

  get secondChart(): Chart | undefined {
    return _.nth(this.chartResources, 1)
  }

  get firstTable(): Table | undefined {
    return _.first(this.tableResources)
  }

  get secondTable(): Table | undefined {
    return this.firstChart === undefined
      ? _.nth(this.tableResources, 1)
      : this.firstTable
  }

  get section1Style(): {background: string} | string | null {
    return this.style1DefaultBg ? this.backgroundImageStyle : this.style1
  }

  get section2Style(): {background: string} | string | null {
    return this.style2DefaultBg ? this.backgroundImageStyle : this.style2
  }

  get pageStyle(): {background: string} | null {
    return this.style1DefaultBg || this.style2DefaultBg
      ? null
      : this.backgroundImageStyle
  }
}
